"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mouse = void 0;
const gl_matrix_1 = require("gl-matrix");
class Mouse {
    constructor() {
        this.click = false;
        this.leftClick = false;
        this.rightClick = false;
        this.position = gl_matrix_1.vec2.create();
        this.delta = gl_matrix_1.vec2.create();
    }
}
exports.Mouse = Mouse;
